import AboutXpKnowMoreDialog from './AboutXpKnowMoreDialog';

const FALLBACK_CONTENT = {
  title: 'Know About RapGems',
  sections: [
    {
      heading: 'What are RapGems?',
      body:
        'RapGems are a premium in-app currency used to unlock your moves and elevate your experience. They are more valuable than regular rewards and are typically used for special actions like boosts and swaps within the platform.',
    },
    {
      heading: 'How to Get RapGems?',
      body: 'RapGems can be obtained through the app during special offers or anytime from the coin store.',
    },
    {
      heading: 'How to Use RapGems?',
      body:
        'Use RapGems to unlock your potential with Swaps and Boosts. Swap can be used to swap the question while playing the RapFire and RapLeague game. Boost can be used to boost your locked RapLeague Card.',
    },
  ],
};

/** Figma 11051:14945–14955 — Know About RapGems dialog */
export default function RapGemKnowMoreDialog({ open, onClose }) {
  return <AboutXpKnowMoreDialog open={open} onClose={onClose} slug="gems" fallbackContent={FALLBACK_CONTENT} />;
}
